// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import Icon_chevron_right from '../../../hola/pub/img/hola2023/icons/16/chevron_right.svg';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../hola/pub/lib/button';
import styles from './case_card.module.less';
import {Settings_context} from '../../../hola/pub/settings_ctx';
import {use_translation_v} from '../../../hola/pub/lib/trans_v';
import cn from 'classnames';

interface i_case_card_props {
    title?: string;
    description?: string;
    button_caption?: string;
    button_link?: string;
    img_url?: string;
}

interface i_case_card_editor_props {
    value: i_case_card_props;
    on_change: (value: i_case_card_props)=>void;
    on_cancel: ()=>void;
}

export const Case_card = (props: i_case_card_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {
        title = 'Shared datacenter proxies best for',
        description = 'A shared datacenter proxy allows multiple users to '+
            'utilize the same IP, offering a cost-effective alternative to '+
            'dedicated proxies while maintaining reliable and efficient '+
            'connectivity. With fast response times and seamless '+
            'integration, shared datacenter proxies are a scalable solution '+
            'for businesses and individuals looking to enhance their online '+
            'operations.',
        button_caption = 'Read more',
        button_link = '',
        img_url = ''
    } = props;
    return <div className={theme.container}>
      <div className={styles.case_card}>
        <div className={styles.text}>
          <p className={cn(theme.p24, theme.med, theme.color_n800)}><T>
            {title}</T></p>
          <p className={cn(theme.p16, theme.reg, theme.color_n700)}><T>
            {description}</T></p>
          {button_caption && <Button
            caption={<T>{button_caption}</T>}
            size='md'
            icon_right={<Icon_chevron_right/>}
            to={button_link || '#'}
            round={false}
            color="transparent_black"
            fit
            cls={styles.button}
          />}
        </div>
        <div className={styles.img}>
          {img_url ?
            <img src={img_url} alt={title} className={styles.custom_img} /> :
            <div className={styles.default_img} />
          }
        </div>
      </div>
    </div>;
};

export const Case_card_editor = (props: i_case_card_editor_props)=>{
    const {value = {}, on_change, on_cancel} = props;
    return <Editor
      value={value}
      editors={[
        {key: 'title', label: 'Card Title', type: 'text'},
        {key: 'description', label: 'Card Description', type: 'textarea'},
        {key: 'button_caption', label: 'Button Caption', type: 'text'},
        {key: 'button_link', label: 'Button Link', type: 'text'},
        {key: 'img_url', label: 'Image URL', type: 'text'},
      ]}
      on_change={on_change}
      on_save={()=>on_change(value)}
      on_cancel={on_cancel}
    />;
};
